import { useState, useRef, useEffect, useCallback } from "react";
import {
  get_all_projects,
  getProjectNames,
} from "../../../../services/projectService";
import {
  AufgangAnimation,
  auf_min,
  open_in_full_icon,
  non_expand,
  history_icon,
  chat_close_icon,
  chatbot_down_arrow,
  chatbot_up_arrow,
  reply_chat,
  chat_mic_off_icon,
  micon,
  chatbot_mic_icon,
  chat_send_icon,
  chat_send_icon_white,
  // chat_refresh_icon,
  back_arrow,
  ai_text_icon,
} from "../../../../assets/images/Images";
import LoadingDots from "../../../atoms/LoadingDots/LoadingDots";
import useUserStore from "../../../../store/userStore";
import useTokenStore from "../../../../store/tokenStore";

import { useParams } from "react-router";
import type { ProjectItem } from "../../../../types/project";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useChatHistoryNavigation } from "../../../../services/chatbotService";

import BeforeExpand from "./ChatPanel";
import type { HistoryModalConfig } from "./HIstoryModal";
import type { ProjectSidebarConfig } from "./ProjectSidebar";
import useChatSessionStore from "../../../../store/chatSessionStore";
import useChatMessageStore from "../../../../store/chatMessagesStore";
import useConfigStore from "../../../../store/configStore";
import useFileUploadStore from "../../../../store/fileUploadStore";
import type { UploadedFileFromAPI } from "../../../../store/chatMessagesStore";
import type { User } from "../../../../types/user";
import type { ChatbotConfig } from "../../../../types/config";
import React from "react";
import styles from "../chatDrawer.module.css";
import { useLocation } from "react-router";


// import { useStore } from "zustand"; // Removed unused import

interface ChatDrawerProps {
  /** Optional custom component to render in suggestions body */
  customSuggestionComponent?: React.ReactNode;
  isOpen: boolean;
  isSearchFieldNeeded?: boolean;
  onClose: () => void;
  setUserObj: User
  config: ChatbotConfig; // Centralized configuration
  userAvatar?: string;
  setToken: string;
  aiAvatar?: string;
  AIAssistantname?: string;
  AIAssistantTitleString?: string;
  suggestionPrompts?: string[];
  aufgangAnimationUrl?: string;
  aufgangAnimationAlt?: string;
  aufMinUrl?: string;
  aufMinAlt?: string;
  logoVideoUrl?: string;
  defaultProjectPlaceholder?: string;
  openInFullIconUrl?: string;
  nonExpandIconUrl?: string;
  historyIconUrl?: string;
  chatCloseIconUrl?: string;
  chatbotDownArrowUrl?: string;
  chatbotUpArrowUrl?: string;
  replyChatIconUrl?: string;
  chatMicOffIconUrl?: string;
  miconUrl?: string;
  chatbotMicIconUrl?: string;
  chatSendIconUrl?: string;
  chatSendIconWhiteUrl?: string;
  chatRefreshIconUrl?: string;
  aiTextIconUrl?: string;
  historyModalConfig?: HistoryModalConfig;
  projectSidebarConfig?: ProjectSidebarConfig;
  loadMoreMessagesText?: string;
  loadingMoreMessagesText?: string;
  loadMoreBottomMessages?: (indexId?: number) => Promise<void> | void;
  isBottomLoading?: boolean;
  sendButtonColor?: string;
  sendButtonHoverColor?: string;
  sendButtonDisabledColor?: string;
  sendButtonTextColor?: string;
  workWebToggleActiveBgColor?: string;
  workWebToggleInactiveTextColor?: string;
  workWebToggleTextColor?: string;
  isHistoryIconVisible?: boolean;
  isProjectDropdownVisible?: boolean;
  isProjectChangeIconVisible?: boolean;
  thinkingText?: string[];
  // Color customization props for FeedbackForm
  feedbackBackgroundColor?: string;
  feedbackBorderColor?: string;
  feedbackTextColor?: string;
  feedbackButtonColor?: string;
  feedbackButtonHoverColor?: string;
  feedbackPlaceholderColor?: string;
  thumbUpIcon?: string;
  thumbDownIcon?: string;
  // Input placeholder customization props
  workModePlaceholder?: string;
  webModePlaceholder?: string;
  listeningPlaceholder?: string;
  aiThinkingPlaceholder?: string;
  isWorkWebEnableForAll?: boolean;
  workLabel?: string;
  webLabel?: string;
  isWebAllowed?: boolean;
  queryMetaData?: Record<string, any> | null;
  isExpandableButtonEnable?: boolean;
  // Optional agent data for custom dropdown population
  agentData?: ProjectItem[];
  // Initial project ID to set when drawer opens with agentData
  initialProjectId?: string;
  // Google Drive integration props (passed to avoid redundant stores)
  /** Google token data for Google Drive integration */
  googleTokenData?: {
    token: string;
    refresh_token: string;
    token_uri: string;
    client_id: string;
    client_secret: string;
    scopes: string[];
    expiry: string;
  } | null;
  /** Auth token for Google Drive API calls */
  googleAuthToken?: string;
  /** Callback to submit Google token to backend after OAuth */
  onGoogleTokenSubmit?: (tokenData: { google_token: any }) => void;
  /** Callback to fetch Google token from backend */
  onGoogleTokenFetch?: () => void;
  /** Callback when file IDs are selected from Google Drive (for embeddings) */
  onGoogleDriveFileIds?: (fileIds: string[]) => void;
  /** Whether to show Google Drive option in file upload modal */
  showGoogleDriveOption?: boolean;
}

export interface Message {
  id: number;
  project_id: string;
  _id: string;
  index_id: number;
  sender: "user" | "ai";
  name: string;
  avatar: string;
  time: string;
  content: React.ReactNode;
  isSpeaking?: boolean;
  isTemp?: boolean;
  project_name?: string;
  reply_message_id?: string | null;
  reply_message?: string | null; // New field for reply message content
  type?: string | null; // New field to indicate web or work mode
  uploaded_files?: UploadedFileFromAPI[]; // Optional field for uploaded files from API
}

// const generateInitials = (firstName: string, lastName: string): string => {
//   const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : "";
//   const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : "";
//   return `${firstInitial}${lastInitial}`;
// };

const ChatDrawer: React.FC<ChatDrawerProps> = ({
  isOpen = false,
  isSearchFieldNeeded,
  onClose,
  config,
  userAvatar = "https://randomuser.me/api/portraits/men/32.jpg",
  aiAvatar = "https://cdn-icons-png.flaticon.com/512/4712/4712035.png",
  // AIAssistantTitleString = "What would you like to know?",
  suggestionPrompts = [
    "What are the three main types of zoning districts in NYC?",
    "What are the height and bulk regulations in R10 districts?",
    "What zoning rules apply to waterfront properties in NYC?",
    "What is the purpose of special purpose districts in NYC?",
  ],
  aufgangAnimationUrl = AufgangAnimation,
  aufgangAnimationAlt = "aufgangAi",
  aufMinUrl = auf_min,
  aufMinAlt = "aufgangAi",
  logoVideoUrl,
  setToken,
  setUserObj,
  openInFullIconUrl = open_in_full_icon,
  nonExpandIconUrl = non_expand,
  AIAssistantname = "Elise AI",
  chatCloseIconUrl = chat_close_icon,
  chatbotDownArrowUrl = chatbot_down_arrow,
  chatbotUpArrowUrl = chatbot_up_arrow,
  replyChatIconUrl = reply_chat,
  chatMicOffIconUrl = chat_mic_off_icon,
  miconUrl = micon,
  historyIconUrl = history_icon,
  chatbotMicIconUrl = chatbot_mic_icon,
  chatSendIconUrl = chat_send_icon,
  chatSendIconWhiteUrl = chat_send_icon_white,
  // chatRefreshIconUrl = chat_refresh_icon,
  aiTextIconUrl = ai_text_icon,
  historyModalConfig,
  projectSidebarConfig,
  loadMoreMessagesText = "Load more messages",
  loadingMoreMessagesText = "Loading more messages...",
  loadMoreBottomMessages,
  isBottomLoading,
  defaultProjectPlaceholder = "Ask Elise",
  sendButtonColor = "#00b2c1",
  sendButtonHoverColor = "#0099a0",
  sendButtonDisabledColor = "#f7f7f7",
  sendButtonTextColor = "#ffffff",
  workWebToggleActiveBgColor = "#e8e5e5",
  workWebToggleInactiveTextColor = "#CCCCCC",
  workWebToggleTextColor = "#0099a0",
  customSuggestionComponent,
  isHistoryIconVisible = true,
  isProjectDropdownVisible = true,
  isProjectChangeIconVisible = true,
  thinkingText = [],
  // Color props for FeedbackForm
  feedbackBackgroundColor,
  feedbackBorderColor,
  feedbackTextColor,
  feedbackButtonColor,
  feedbackButtonHoverColor,
  feedbackPlaceholderColor,
  thumbUpIcon,
  thumbDownIcon,
  // Input placeholder props with defaults
  workModePlaceholder = "Ask about emails or files…",
  webModePlaceholder = "Search the web…",
  listeningPlaceholder = "Listening",
  aiThinkingPlaceholder = "AI is thinking...",
  isWorkWebEnableForAll,
  workLabel,
  webLabel,
  isWebAllowed,
  queryMetaData = null,
  isExpandableButtonEnable = true,
  agentData,
  initialProjectId,
  // Google Drive props
  googleTokenData,
  googleAuthToken,
  onGoogleTokenSubmit,
  onGoogleTokenFetch,
  onGoogleDriveFileIds,
  showGoogleDriveOption = true,
}) => {
  const { project_id } = useParams();
  const { user, refetchAuthStatus } = useUserStore();
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const recognitionRef = useRef<any>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const projectNamesCache = useRef<string[] | null>(null);
  const debounceTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const wsRef = useRef<WebSocket | null>(null);
  const loadingMessageIdRef = useRef<number | null>(null);
  const chatContainerRef = useRef<HTMLDivElement | null>(null);
  const isConnectingRef = useRef<boolean>(false);
  const currentWsUrlRef = useRef<string | null>(null); // Track current WebSocket URL
  const pendingResponseRef = useRef<boolean>(false); // Track if there's a pending response
  const isOpenRef = useRef<boolean>(isOpen); // Track drawer open state to avoid stale closures
  const lastConnectedProjectIdRef = useRef<string | null>(null); // Track last connected project ID to prevent duplicate connections
  const lastWebModeRef = useRef<boolean | null>(null); // Track last web mode to detect mode changes
  const hasInitializedForOpenRef = useRef<boolean>(false); // Track if we've initialized connection for current drawer open
  const wasListeningRef = useRef<boolean>(false); // Track previous mic state so the fade-out only runs on a real stop
  const location = useLocation();



  const [inputValue, setInputValue] = useState("");
  const {
    fetchChatSessions,
    selectedSessionId,
    setSelectedSessionId,
    sessionIsOn,
    setSessionIsOn,
    dropdownSelectedProjectId,
    setDropdownSelectedProjectId,
    setShowNavigationArrows,
    // showNavigationArrows,
  } = useChatSessionStore();
  const [isListening, setIsListening] = useState(false);
  const [listeningDots, setListeningDots] = useState("");
  const [stopReconnectionSocket, setStopReconnectionSocket] = useState(false);

  const [showMentionList, setShowMentionList] = useState(false);
  const setTokenfn = useTokenStore((state) => state.setToken);
  const setBaseUrl = useTokenStore((state) => state.setUniBaseUrl);
  //const {token} = useTokenStore();

  const setUserfn = useUserStore((state) => state.setUser)
  const setConfig = useConfigStore((state) => state.setConfig);
  const prevScrollTopRef = useRef(0); // Track the previous scrollTop position
  const prevScrollHeightRef = useRef(0); // Track the previous scrollHeight to detect content changes

  const mergedHistoryModalConfig: HistoryModalConfig = {
    title: "History",
    backIconUrl: back_arrow,
    closeIconUrl: chatCloseIconUrl,
    searchPlaceholder: "Search in Projects",
    noResultsText: "No results found.",
    ...historyModalConfig,
  };
  const mergedProjectSidebarConfig: ProjectSidebarConfig = {
    title: AIAssistantname ?? "My AI",
    logoAnimationUrl: aufgangAnimationUrl,
    logoOverlayUrl: aufMinUrl,
    logoAnimationAlt: aufgangAnimationAlt,
    logoOverlayAlt: aufMinAlt,
    logoVideoUrl,
    logoVideoAlt: aufgangAnimationAlt,
    searchPlaceholder: "Search in Projects",
    noResultsText: "No history found",
    ...projectSidebarConfig,
  };
  const {
    chatMessages,
    appendAtEndChatMessages,
    replaceChatMessages,
    chatMessageIsLoading,
    // clearAndSetChatMessages,
    refreshChatMessages,
    setShowSuggestions,
    replyMessage,
    replyToMessageId,
    replyToIndexId,
    setReplyMessage,
    setReplyToMessageId,
    setReplyToIndexId,
    IsWebEnabled,
    setIsWebEnabled,
    // isAIResponding,
    setIsAIResponding,
    setAiAssistantName,
  } = useChatMessageStore();
  const [dropdownSearchQuery] = useState("");
  // console.log(setDropdownSearchQuery)
  const [showDropdown, setShowDropdown] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState(false);

  // const [AIAssistantTitle, setAIAssistantTitle] = useState(
  //   "What would you like to know?"
  // );
  const [mentionQuery, setMentionQuery] = useState("");
  const [mentionStart, setMentionStart] = useState<number | null>(null);
  const [mentionActiveIndex, setMentionActiveIndex] = useState(0);
  const [projectNames, setProjectNames] = useState<string[]>([]);
  const isStreamCompleted = useRef(true);

  const [isFetchingProjects, setIsFetchingProjects] = useState(false);
  const [isMicTransitioning, setIsMicTransitioning] = useState(false);
  const [isMicHovered, setIsMicHovered] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false); // Track visibility of scroll 
 const showScrollButtonRef = useRef(false);
  const [showHistory, setShowHistory] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [copiedMessageId, setCopiedMessageId] = useState<number | null>(null);
  // const [showLoadMoreDown, setShowLoadMoreDown] = useState(true);
  const [openDropdownMessageId, setOpenDropdownMessageId] = useState<
    number | null
  >(null);
  const [hoveredButton, setHoveredButton] = useState<{
    id: number;
    type: "copy" | "Like" | "speaker" | "switch_project";
  } | null>(null);
  const [totalSessionCount, setTotalSessionCount] = useState<number | null>(
    null
  );
  const [currentIndexInSession, setCurrentIndexInSession] = useState<number>(1);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [currentIndexId, setCurrentIndexId] = useState<number | undefined>(
    undefined
  );
  const backendAiMessageIdRef = useRef<string | null>(null);
  const messagesRef = useRef<Message[]>(chatMessages || []);
  const isUpdatingSpeakingStateRef = useRef<boolean>(false);
  const currentUtteranceRef = useRef<SpeechSynthesisUtterance | null>(null);
  const isHandlingSpeakerClickRef = useRef<boolean>(false);



  const historyModalRef = useRef<{
    fetchSessions: (search: string) => void;
  } | null>(null);

  const handleIconMouseEnter = (
    iconId: number,
    type: "copy" | "Like" | "speaker" | "switch_project"
  ) => setHoveredButton({ id: iconId, type });
  const handleIconMouseLeave = () => setHoveredButton(null);

  const [_messagesTrigger, setMessagesTrigger] = useState(false); // Used to trigger re-renders
  // console.log(_messagesTrigger)

  const handleSpeakerClick = (id: number, text: string) => {
    // Prevent duplicate calls
    if (isHandlingSpeakerClickRef.current) {
      return;
    }
    isHandlingSpeakerClickRef.current = true;

    // Set flag to indicate we're updating speaking state (prevents unwanted scrolling)
    isUpdatingSpeakingStateRef.current = true;

    // First, cancel any ongoing speech synthesis
    // Clear the onend handler of the current utterance to prevent it from firing
    if (currentUtteranceRef.current) {
      currentUtteranceRef.current.onend = null;
      currentUtteranceRef.current = null;
    }

    if ("speechSynthesis" in window) {
      window.speechSynthesis.cancel();
    }

    // Check current state BEFORE updating
    const clickedMessage = messagesRef.current.find((msg) => msg.id === id);
    const isCurrentlySpeaking = clickedMessage?.isSpeaking || false;

    // If clicking the same message that's already speaking, just stop it
    if (isCurrentlySpeaking) {
      updateMessages((prevMessages) =>
        prevMessages.map((msg) => ({
          ...msg,
          isSpeaking: false,
        }))
      );
      setTimeout(() => {
        isHandlingSpeakerClickRef.current = false;
        isUpdatingSpeakingStateRef.current = false;
      }, 100);
      return;
    }

    // Update state first (stop all other messages, mark this one as speaking)
    updateMessages((prevMessages) =>
      prevMessages.map((msg) => {
        if (msg.id === id) {
          return { ...msg, isSpeaking: true };
        }
        return { ...msg, isSpeaking: false };
      })
    );

    // THEN do the side effect (speak) OUTSIDE the callback to ensure it only runs once
    if ("speechSynthesis" in window) {
      // Clean the text by removing/replacing special characters for better speech
      const cleanText = text
        .replace(/[-–—]/g, " ") // Replace dashes with spaces
        .replace(/[^\w\s.,!?;:()]/g, "") // Remove other special characters except basic punctuation
        .replace(/\s+/g, " ") // Replace multiple spaces with single space
        .trim(); // Remove leading/trailing spaces

      // Create new utterance
      const utterance = new window.SpeechSynthesisUtterance(cleanText);

      // Set up onend callback with flag management
      utterance.onend = () => {
        // Only update if this utterance is still the current one (wasn't cancelled)
        if (currentUtteranceRef.current === utterance) {
          // Set flag before updating to prevent scrolling
          isUpdatingSpeakingStateRef.current = true;
          updateMessages((msgs) =>
            msgs.map((m) =>
              m.id === id ? { ...m, isSpeaking: false } : m
            )
          );
          // Reset flags after update completes
          setTimeout(() => {
            isUpdatingSpeakingStateRef.current = false;
            currentUtteranceRef.current = null;
          }, 100);
        }
      };

      // Store reference to prevent duplicates and track current utterance
      currentUtteranceRef.current = utterance;
      window.speechSynthesis.speak(utterance);
    }

    // Reset handling flag after initial state update completes
    setTimeout(() => {
      isHandlingSpeakerClickRef.current = false;
      // Only reset scroll flag if we're not currently speaking (onend will handle it otherwise)
      if (!currentUtteranceRef.current) {
        isUpdatingSpeakingStateRef.current = false;
      }
    }, 100);
  };

  // Conditionally fetch projects only if agentData is not provided
  const { data: projectsList } = useQuery<{
    projects: ProjectItem[];
    isNewFormat: boolean;
    originalResponse: any;
  }>({
    queryKey: ["get_all_projects"], // Include dependencies
    queryFn: () =>
      get_all_projects({
        filters: {
          page: 1,
          limit: 100,
          search: "",
        },
      }),
    placeholderData: keepPreviousData, // v5: replaces keepPreviousData: true
    retry: 2,
    staleTime: Infinity,
    gcTime: Infinity, // v5: renamed from cacheTime
    enabled: !agentData, // Skip API call if agentData is provided
  });

  // Use agentData if provided, otherwise use projectsList
  const effectiveProjectsList = agentData
    ? {
      projects: agentData,
      isNewFormat: true,
      originalResponse: null,
    }
    : projectsList;

  const connectWebSocket = (projectId: string,
    // retryCount = 0
  ) => {
    // Prevent duplicate connection attempts
    if (isConnectingRef.current) {
      console.log('WebSocket connection already in progress, skipping duplicate call');
      return;
    }

    const baseUrl = config.websocketUrl;
    const local_timezone_name = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // let websocketUrlFinal = `${baseUrl}?token=${user?._id ? user?._id : setUserObj._id}&timezone=${local_timezone_name}`;
    // let websocketUrlFinal = `${baseUrl}?token=${user?._id ? user?._id : setUserObj._id}&timezone=${local_timezone_name}&agent_type=default`;

    // to send the lesson id on the lesson generator page to the backend -- Novesh
    const searchParams = new URLSearchParams(location.search);
    const isNewLessonsPage =
    location.pathname === "/NewLessons" &&
    searchParams.has("lesson_id") &&
    searchParams.has("course_id") &&
    searchParams.has("teacher_id");

    // Lesson overview page: IDs come from the path, not query params
    // e.g. /course/448773/lesson/612289/overview
    const overviewMatch = location.pathname.match(
      /^\/course\/([^/]+)\/lesson\/([^/]+)\/overview\/?$/
    );
    
    const isLessonOverviewPage = Boolean(overviewMatch);

    let params = new URLSearchParams({
      token: user?._id || setUserObj._id,
      timezone: local_timezone_name,
    });

    if (isNewLessonsPage) {
      const lessonId = searchParams.get("lesson_id");

      if (lessonId) {
        params.append("lesson_id", lessonId);
      }
    }

    if (isLessonOverviewPage && overviewMatch) {
      const lessonId = overviewMatch[2]; // capture group 2 = lesson id
      if (lessonId) {
        params.append("lesson_id", lessonId);
      }
    }

    let websocketUrlFinal = `${baseUrl}?${params.toString()}`;

    // Convert projectId to string and check if it's a valid non-empty value
    const projectIdStr = String(projectId || "");
    if (projectIdStr && projectIdStr !== "" && projectIdStr !== "None") {
      // Use the value as-is (can be number or string) for agent_type
      websocketUrlFinal += `&agent_type=${projectIdStr}&chat_type=school`;
      // websocketUrlFinal += `&project_id=${projectIdStr}`;
    } else if (IsWebEnabled) {
      websocketUrlFinal += `&chat_type=web&agent_type=default`;
    } else {
      websocketUrlFinal += `&chat_type=school&agent_type=default`;
    }

    // Check if we already have a connection with the same URL
    if (
      wsRef.current &&
      wsRef.current.readyState === WebSocket.OPEN &&
      currentWsUrlRef.current === websocketUrlFinal
    ) {
      console.log('WebSocket already connected with same parameters, reusing connection');
      isConnectingRef.current = false;
      return;
    }

    isConnectingRef.current = true;

    // Only close existing connection if URL is different or connection is not open
    if (wsRef.current) {
      // Don't close if there's a pending response and the URL is the same
      if (pendingResponseRef.current && currentWsUrlRef.current === websocketUrlFinal) {
        console.log('Pending response detected, keeping existing connection');
        isConnectingRef.current = false;
        return;
      }
      console.log('close connection 1');
      wsRef.current.close();
      wsRef.current = null;
      setConnectionStatus(false);
    }

    currentWsUrlRef.current = websocketUrlFinal;
    wsRef.current = new WebSocket(websocketUrlFinal);

    wsRef.current.onopen = () => {
      console.log("WebSocket connection opened.");
      isStreamCompleted.current = false;
      setConnectionStatus(true);
      isConnectingRef.current = false;
    };

    wsRef.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.message === "<STARTOFTURN>") {
          pendingResponseRef.current = true; // Mark that we're expecting a response
          return;
        }
        if (data.message === "<ENDOFTURN>") {
          pendingResponseRef.current = false; // Response is complete
          setIsAIResponding(false);
          loadingMessageIdRef.current = null;

          const handleFinalMessage = (event2: MessageEvent) => {
            try {
              const finalData = JSON.parse(event2.data);
              // Check for _id in both top-level and data wrapper
              const rawId = finalData._id || finalData.data?._id;
              const rawIndexId = finalData.index_id || finalData.data?.index_id;
              const rawType = finalData.type || finalData.data?.type;

              if (rawId) {
                // Parse _id to integer if it's a numeric string, otherwise keep as string
                const parsedId = typeof rawId === "string" && /^\d+$/.test(rawId)
                  ? String(parseInt(rawId, 10))
                  : String(rawId);

                backendAiMessageIdRef.current = parsedId;
                // Update the last AI message with empty _id
                const updatedMessages = messagesRef.current.map(
                  (msg, idx, arr) =>
                    msg.sender === "ai" &&
                      (!msg._id || msg._id === "") &&
                      idx === arr.length - 1
                      ? {
                        ...msg,
                        _id: parsedId,
                        index_id: rawIndexId || msg.index_id,
                        // Update type field from backend response to align with backend
                        type: rawType || msg.type,
                      }
                      : msg
                );
                updateMessages(() => updatedMessages);
                useChatMessageStore.getState().setChatMessages(updatedMessages);

                // Refresh chat sessions after new message is saved
                fetchChatSessions("");
              }
            } catch (err) {
              // ignore
            }
            if (wsRef.current) {
              wsRef.current.removeEventListener("message", handleFinalMessage);
            }

            // Close WebSocket if drawer is closed and response is complete
            if (!isOpenRef.current && wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
              console.log('Closing WebSocket after response complete - drawer is closed');
              wsRef.current.close();
              wsRef.current = null;
              currentWsUrlRef.current = null;
              setConnectionStatus(false);
            }
          };
          if (wsRef.current) {
            wsRef.current.addEventListener("message", handleFinalMessage);
          }

          // Also check immediately if drawer is closed (in case handleFinalMessage doesn't fire)
          setTimeout(() => {
            if (!isOpenRef.current && wsRef.current && wsRef.current.readyState === WebSocket.OPEN && !pendingResponseRef.current) {
              console.log('Closing WebSocket after response complete - drawer is closed (timeout check)');
              wsRef.current.close();
              wsRef.current = null;
              currentWsUrlRef.current = null;
              setConnectionStatus(false);
            }
          }, 1000); // Wait 1 second to ensure final message is processed

          return;
        }
        if (loadingMessageIdRef.current !== null) {
          updateMessages((prev) =>
            prev.map((msg) =>
              msg.id === loadingMessageIdRef.current
                ? {
                  ...msg,
                  content:
                    typeof msg.content === "string"
                      ? msg.content + (data?.message || "")
                      : data?.message || "",
                  time: new Date().toLocaleString([], {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }),
                }
                : msg
            )
          );
          // Use longer timeout when isExpanded is false (dev/qat environments need more time)
          const scrollTimeout = isExpanded ? 0 : 100;
          setTimeout(() => {
            if (messagesEndRef.current && !showScrollButtonRef.current) {
              messagesEndRef.current.scrollIntoView({ behavior: "auto" });
            }
          }, scrollTimeout);
        }
      } catch (err) {
        console.error("Error parsing WebSocket message", err);
      }
    };

    wsRef.current.onerror = (_error) => {
      console.log("WebSocket error:", _error);
      // if (navigator.onLine) {
      // console.log(_error)
      isStreamCompleted.current = true;
      setIsAIResponding(false);
      pendingResponseRef.current = false; // Reset pending response on error
      setConnectionStatus(false);
      isConnectingRef.current = false;

      // }
      // console.error("WebSocket error:", error);
      // // retry connection
      // if (
      //   isOpen &&
      //   retryCount < 5 &&
      //   wsRef.current?.readyState !== WebSocket.OPEN
      // ) {
      //   // Only try to reconnect if the browser is online
      //   if (navigator.onLine) {
      //     setTimeout(() => {
      //       if (wsRef.current) {
      //         wsRef.current.close();
      //       }
      //       connectWebSocket(projectId, retryCount + 1);
      //     }, 2000);
      //   } else {
      //     // Optionally, listen for the 'online' event to trigger reconnect
      //     const handleOnline = () => {
      //       connectWebSocket(projectId, retryCount + 1);
      //       window.removeEventListener("online", handleOnline);
      //     };
      //     window.addEventListener("online", handleOnline);
      //   }
      // }
    };

    wsRef.current.onclose = (_event) => {
      console.log("WebSocket connection closed.");
      console.log("🔴 WebSocket CLOSED - Debug Info:", {
        code: _event.code,
        reason: _event.reason || "(no reason provided)",
        wasClean: _event.wasClean,
        timestamp: new Date().toISOString(),
        url: currentWsUrlRef.current,
        connectionDuration: "Check timestamps in console",
      });
      // console.log(_event)
      isStreamCompleted.current = true;
      setIsAIResponding(false);
      pendingResponseRef.current = false; // Reset pending response on close
      setConnectionStatus(false);
      isConnectingRef.current = false;
      // Only clear URL if we're not expecting a response
      if (!pendingResponseRef.current) {
        currentWsUrlRef.current = null;
        lastConnectedProjectIdRef.current = null; // Reset last connected project ID
      }

      // if (navigator.onLine) {
      //   isStreamCompleted.current = true;
      //   setIsAIResponding(false);
      // }
    };


  };

  useEffect(() => {
    // check online or  offline
    const handleOnline = () => {
      connectWebSocket(dropdownSelectedProjectId || "");
    };
    setTokenfn(setToken);
    setUserfn(setUserObj);
    setBaseUrl(config.baseUrl); // Use config.baseUrl instead of uniBaseUrl
    setConfig(config); // Initialize the config store
    // console.log(`the current value of tkken is     ${token}`);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, [config]);


  // Update isOpenRef whenever isOpen changes
  useEffect(() => {
    const wasOpen = isOpenRef.current;
    isOpenRef.current = isOpen;

    // Reset initialization flag when drawer closes
    if (wasOpen && !isOpen) {
      hasInitializedForOpenRef.current = false;
      lastConnectedProjectIdRef.current = null;
      lastWebModeRef.current = null;
    }
  }, [isOpen]);

  // Consolidated effect: Handle initialProjectId setting and WebSocket connection together
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    // Step 1: Set initialProjectId if provided (only once per drawer open)
    if (agentData && initialProjectId && !hasInitializedForOpenRef.current) {
      if (dropdownSelectedProjectId !== initialProjectId) {
        console.log('Setting initialProjectId on drawer open', { initialProjectId });
        setDropdownSelectedProjectId(initialProjectId);
        // Mark as initialized - we'll connect after this state update
        hasInitializedForOpenRef.current = true;
        return; // Exit early, let the next render handle the connection
      } else {
        hasInitializedForOpenRef.current = true;
      }
    } else if (!agentData || !initialProjectId) {
      // Reset to null if no initialProjectId provided (only once per drawer open)
      if (!hasInitializedForOpenRef.current && dropdownSelectedProjectId !== null) {
        console.log('Resetting project ID on drawer open (no initialProjectId)');
        setDropdownSelectedProjectId(null);
        hasInitializedForOpenRef.current = true;
        return; // Exit early, let the next render handle the connection
      } else {
        hasInitializedForOpenRef.current = true;
      }
    }

    // Step 2: Connect WebSocket (only if we've initialized or if project/web mode changed)
    if (!hasInitializedForOpenRef.current) {
      return; // Wait for initialization
    }

    const projectIdToUse = dropdownSelectedProjectId || "";

    // Check if we need to reconnect (project changed OR web mode changed)
    const projectChanged = lastConnectedProjectIdRef.current !== projectIdToUse;
    const webModeChanged = lastWebModeRef.current !== IsWebEnabled;
    const needsReconnect = projectChanged || webModeChanged;

    // Prevent duplicate connection if we're already connected or connecting with the same config
    if (!needsReconnect && lastConnectedProjectIdRef.current === projectIdToUse && lastWebModeRef.current === IsWebEnabled) {
      if (wsRef.current) {
        const readyState = wsRef.current.readyState;
        if (readyState === WebSocket.OPEN) {
          console.log('WebSocket already connected with same config, skipping reconnection', { projectIdToUse, IsWebEnabled });
          return;
        } else if (readyState === WebSocket.CONNECTING) {
          console.log('WebSocket already connecting with same config, skipping duplicate connection', { projectIdToUse, IsWebEnabled });
          return;
        }
      }
    }

    lastConnectedProjectIdRef.current = projectIdToUse;
    lastWebModeRef.current = IsWebEnabled;
    connectWebSocket(projectIdToUse);
  }, [isOpen, dropdownSelectedProjectId, IsWebEnabled, initialProjectId, agentData]);

  // Cleanup effect for drawer close
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    return () => {
      // Don't close WebSocket if there's a pending response
      if (wsRef.current && !pendingResponseRef.current) {
        console.log('Closing WebSocket connection - drawer closed and no pending response');
        wsRef.current.close();
        wsRef.current = null;
        currentWsUrlRef.current = null;
        setConnectionStatus(false);
        isConnectingRef.current = false;
        lastConnectedProjectIdRef.current = null;
        lastWebModeRef.current = null;
        hasInitializedForOpenRef.current = false;
      } else if (pendingResponseRef.current) {
        console.log('Keeping WebSocket open - pending response detected');
      }
    };
  }, [isOpen]);





  // Animate the "listening..." dots while the mic is on, and run a short
  // fade-out transition when it turns off.
  // NOTE: isMicTransitioning must NOT be a dependency here - this effect sets it,
  // so depending on it made the effect re-trigger itself in a permanent 500ms
  // re-render loop (drawer DOM churned continuously even when idle).
  useEffect(() => {
    if (isListening) {
      wasListeningRef.current = true;
      setListeningDots("");
      setIsMicTransitioning(false);
      const interval = setInterval(() => {
        setListeningDots((prev) => (prev.length < 3 ? prev + "." : ""));
      }, 500);
      return () => clearInterval(interval);
    }

    // Only transition on an actual listening -> not-listening change, not on mount
    if (!wasListeningRef.current) return;
    wasListeningRef.current = false;

    setIsMicTransitioning(true);
    const timeout = setTimeout(() => {
      setListeningDots("");
      setIsMicTransitioning(false);
    }, 500);
    return () => clearTimeout(timeout);
  }, [isListening]);

  useEffect(() => {
    if (project_id) {
      setDropdownSelectedProjectId(project_id || "");
    }
  }, [project_id]);

  // Note: initialProjectId handling is now consolidated in the WebSocket connection useEffect above
  // This prevents the two useEffects from triggering each other


  useEffect(() => {
    setAiAssistantName(AIAssistantname);
  }, [AIAssistantname, setAiAssistantName]);

  // Wrapper to ensure WebSocket is open before sending
  const ensureWebSocketAndSend = async (prompt?: string) => {
    // If WebSocket is open, call handleSend directly
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      await handleSend(prompt);
      setStopReconnectionSocket(false);
      return;
    }

    if (stopReconnectionSocket) return;
    // If not open, try to connect and retry handleSend after 1 second
    connectWebSocket(dropdownSelectedProjectId || "");
    setStopReconnectionSocket(true);
    setTimeout(() => {
      // Recursively call until connection is open
      ensureWebSocketAndSend(prompt);
    }, 1000);
  };

  // Original handleSend function (no change to logic)
  const handleSend = async (prompt?: string) => {
    const invalue = inputValue.trim() || prompt;
    if (!invalue) return;
    // Use longer timeout when isExpanded is false (dev/qat environments need more time)
     showScrollButtonRef.current = false;
      setShowScrollButton(false);
    const scrollTimeout = isExpanded ? 0 : 100;
    setTimeout(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, scrollTimeout);

    setIsAIResponding(true);

    // check if session is selected
    const wasInNavigation = sessionIsOn === true;
    if (wasInNavigation) {
      // Exit navigation mode but don't refresh messages yet
      setSessionIsOn(false);
      setSelectedSessionId("");
      setShowNavigationArrows(false);
    }
    const now = new Date();
    const time = now.toLocaleString([], {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }); // Generate temporary IDs that won't conflict with MongoDB IDs
    const tempId = Date.now();

    // Get attached files from store to include in the message
    const { attachedFiles } = useFileUploadStore.getState();
    // Transform attached files to UploadedFileFromAPI format (only completed uploads)
    const uploadedFilesForMessage = attachedFiles
      .filter((file) => file.uploadStatus === "completed" && file.fileUrl && file.collection_name)
      .map((file) => ({
        file_url: file.fileUrl!,
        file_name: file.name,
        collection_name: file.collection_name!,
      }));

    const newMessage: Message = {
      id: tempId,
      project_id: dropdownSelectedProjectId || "",
      _id: "",
      index_id: 0,
      sender: "user",
      name: user?.user_name || "User",
      avatar: userAvatar,
      time,
      content: invalue,
      isTemp: true, // Add flag to identify temporary messages
      project_name: findProjectNameById(dropdownSelectedProjectId || ""),
      reply_message_id: replyToMessageId || null,
      reply_message:
        replyMessage?.content != null ? String(replyMessage.content) : null,
      // Include uploaded files if any
      uploaded_files: uploadedFilesForMessage.length > 0 ? uploadedFilesForMessage : undefined,
    };

    if (wasInNavigation) {
      try {
        await refreshChatMessages();
        // Add a small delay to ensure UI updates properly
        await new Promise((resolve) => setTimeout(resolve, 100));
        // After refreshing, add the new message to the end
        updateMessages((prev) => [...prev, newMessage]);
        useChatMessageStore.getState().setChatMessages(messagesRef.current);
      } catch (error) {
        console.error("Error refreshing messages:", error);
        // If refresh fails, still add the message
        updateMessages((prev) => [...prev, newMessage]);
        useChatMessageStore.getState().setChatMessages(messagesRef.current);
      }
    } else {
      // Normal flow - just add the message
      updateMessages((prev) => [...prev, newMessage]);
      useChatMessageStore.getState().setChatMessages(messagesRef.current);
    }

    setInputValue("");
    setShowSuggestions(false); // Hide suggestions after sending a message
    // Add loading message for AI response
    const loadingMessage: Message = {
      id: tempId + 1,
      project_id: dropdownSelectedProjectId || "",
      _id: "",
      index_id: 0,
      sender: "ai",
      name: AIAssistantname ?? "My AI",
      avatar: aiAvatar,
      time: new Date().toLocaleString([], {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
      content: (
        <LoadingDots
          className="py-4 px-2"
          projectName={findProjectNameById(dropdownSelectedProjectId || "")}
          thinkingText={thinkingText}
        />
      ),
      isTemp: true,
      project_name: findProjectNameById(dropdownSelectedProjectId || ""),
      type: IsWebEnabled ? "Web" : "School",
    };
    // ...existing code...

    updateMessages((prev) => [...prev, loadingMessage]);
    useChatMessageStore.getState().setChatMessages(messagesRef.current);
    loadingMessageIdRef.current = loadingMessage.id;
    // Send message via WebSocket
    // Ensure WebSocket is connected before sending
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      // Reconnect if not connected
      console.log('WebSocket not connected, attempting to reconnect...');
      connectWebSocket(dropdownSelectedProjectId || "");
      // Wait a bit for connection to establish
      await new Promise((resolve) => setTimeout(resolve, 500));
    }

    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      // const plainMessage = newMessage.content?.toString().replace(/@/g, "");
      const plainMessage = newMessage.content?.toString();

      // Get rag_collection_names from store
      const { ragCollectionNames, clearRagCollectionNames, clearAttachedFiles } = useFileUploadStore.getState();

      if (replyToMessageId && replyToIndexId !== undefined) {
        const replyPayload: any = {
          query: plainMessage,
          // index_id: currentIndexId,
          index_id: replyToIndexId,
          action: "reply",
          message_id: replyToMessageId,
          // message_id: replyToMessageId,
        };
        if (queryMetaData !== null && queryMetaData !== undefined) {
          replyPayload.queryMetaData = queryMetaData;
        }
        // Add rag_collection_name if available
        if (ragCollectionNames && ragCollectionNames.length > 0) {
          replyPayload.rag_collection_name = ragCollectionNames;
        }
        wsRef.current.send(JSON.stringify(replyPayload));
        // Clear attached files and collection names after sending
        clearRagCollectionNames();
        clearAttachedFiles();
        setReplyToMessageId(null); // Reset after sending
        setReplyMessage(null);
      } else {
        const messagePayload: any = {
          query: plainMessage,
          action: "chat",
        };
        if (queryMetaData !== null && queryMetaData !== undefined) {
          messagePayload.queryMetaData = queryMetaData;
        }
        // Add rag_collection_name if available
        if (ragCollectionNames && ragCollectionNames.length > 0) {
          messagePayload.rag_collection_name = ragCollectionNames;
        }
        wsRef.current.send(JSON.stringify(messagePayload));
        // Clear attached files and collection names after sending
        clearRagCollectionNames();
        clearAttachedFiles();
      }
    } else {
      // Clear attached files even when WebSocket fails to send
      const { clearRagCollectionNames, clearAttachedFiles } = useFileUploadStore.getState();
      clearRagCollectionNames();
      clearAttachedFiles();

      updateMessages((prev) =>
        prev.map((msg) =>
          msg.id === loadingMessage.id
            ? {
              ...msg,
              content: "I couldn't process that request at the moment. Please retry or refresh the page.",
              time: new Date().toLocaleString([], {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              }),
            }
            : msg
        )
      );
      loadingMessageIdRef.current = null;
    }
  };

  const fetchProjectNames = useCallback(async () => {
    setIsFetchingProjects(true);
    try {
      if (projectNamesCache.current) {
        setProjectNames(projectNamesCache.current);
      } else {
        const fetcher = getProjectNames;
        const names = await fetcher();
        projectNamesCache.current = names;
        setProjectNames(names);
      }
    } catch (err) {
      setProjectNames([]);
    }
    setIsFetchingProjects(false);
  }, []);
  const debouncedFetchProjectNames = () => {
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      fetchProjectNames();
    }, 300);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setInputValue(value);

    const cursor = e.target.selectionStart || 0;
    const lastAt = value.lastIndexOf("@", cursor - 1);

    if (
      lastAt !== -1 &&
      (lastAt === 0 || /\s/.test(value.charAt(lastAt - 1))) &&
      (cursor === lastAt + 1 ||
        /^[\w-]+$/.test(value.slice(lastAt + 1, cursor)))
    ) {
      let end = cursor;
      while (end < value.length && /\S/.test(value.charAt(end))) end++;
      const mentionText = value.slice(lastAt + 1, cursor);
      setShowMentionList(true);
      setMentionStart(lastAt);
      setMentionQuery(mentionText);
      setMentionActiveIndex(0);
      if (!projectNamesCache.current && !isFetchingProjects) {
        debouncedFetchProjectNames();
      }
    } else {
      setShowMentionList(false);
      setMentionStart(null);
      setMentionQuery("");
      setMentionActiveIndex(0);
    }
  };

  let filteredProjectNames = projectNames;
  if (mentionQuery) {
    filteredProjectNames = projectNames.filter((name) =>
      name.toLowerCase().includes(mentionQuery.toLowerCase())
    );
  }
  filteredProjectNames = filteredProjectNames.slice(0, 5);

  const handleMentionSelect = (name: string) => {
    if (mentionStart === null) return;
    const before = inputValue.slice(0, mentionStart);
    const after = inputValue.slice(
      (mentionStart || 0) + mentionQuery.length + 1
    );
    const newValue = `${before}@${name} ${after}`;
    setInputValue(newValue);
    setShowMentionList(false);
    setMentionStart(null);
    setMentionQuery("");
    setMentionActiveIndex(0);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        // inputRef.current.setSelectionRange(
        //   (before + "@" + name + " ").length,
        //   (before + "@" + name + " ").length
        // );
      }
    }, 0);
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (showMentionList && filteredProjectNames.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setMentionActiveIndex(
          (prev) => (prev + 1) % filteredProjectNames.length
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setMentionActiveIndex(
          (prev) =>
            (prev - 1 + filteredProjectNames.length) %
            filteredProjectNames.length
        );
      } else if (e.key === "Enter") {
        e.preventDefault();
        const selectedProject = filteredProjectNames[mentionActiveIndex];
        if (selectedProject) {
          handleMentionSelect(selectedProject);
        }
      } else if (e.key === "Escape") {
        setShowMentionList(false);
      }
    }
    if (e.key === "Enter" && !showMentionList) {
      if (e.shiftKey) {
        // Allow newline on Shift + Enter
        return;
      }
      ensureWebSocketAndSend();
    }
  };

  const handleSuggestionClick = (prompt: string) => {
    setInputValue(prompt);
    ensureWebSocketAndSend(prompt);
  };

  const handleMicClick = () => {
    if (
      !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
    ) {
      alert("Speech recognition is not supported in this browser.");
      return;
    }

    if (!recognitionRef.current) {
      const SpeechRecognition =
        (window as any).SpeechRecognition ||
        (window as any).webkitSpeechRecognition;
      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.continuous = false;
      recognitionRef.current.interimResults = false;
      recognitionRef.current.lang = "en-US";

      recognitionRef.current.onresult = (event: any) => {
        const transcript = event.results[0][0].transcript;
        setInputValue((prev) => (prev ? prev + " " + transcript : transcript));
      };

      recognitionRef.current.onerror = () => {
        setTimeout(() => {
          setIsListening(false);
        }, 500);
      };

      recognitionRef.current.onend = () => {
        setTimeout(() => {
          setIsListening(false);
        }, 500);
      };
    }

    if (isListening) {
      recognitionRef.current.stop();
    } else {
      recognitionRef.current.start();
      setIsListening(true);
    }
  };

  const highlightProjectNames = (text: string) => {
    if (!projectNames.length) return text;

    // Use flatMap to handle invalid values - returns empty array for non-strings
    const escapedNames = projectNames.flatMap((name) => {
      if (typeof name === 'string' && name.length > 0) {
        return [name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")];
      }
      return [];
    });

    if (!escapedNames.length) return text;

    const regex = new RegExp(`\\b(${escapedNames.join("|")})\\b`, "gi");
    return text.split(regex).map((part, i) => {
      const isValidProjectName = projectNames.some(
        (name) => typeof name === 'string' && name.toLowerCase() === part.toLowerCase()
      );
      return isValidProjectName ? (
        <span key={i} className={"projectHighlight"}>
          {part}
        </span>
      ) : (
        part
      );
    });
  };

  const handleClickOutsideDropdown = (event: MouseEvent): void => {
    // Check if the click is outside the drawer and dropdown
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target as Node) && // Click outside the drawer
      !dropdownRef.current?.contains(event.target as Node) // Click outside the dropdown
    ) {
      setShowDropdown(false); // Close the dropdown
    }
  };

  useEffect(() => {
    // Refetch settings and projects on mount
    // refetchAuthStatus();
    fetchProjectNames();
    fetchChatSessions("");

    // Add event listener to listen for clicks outside the drawer and dropdown
    document.addEventListener("mousedown", handleClickOutsideDropdown);

    // Cleanup: Remove event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDropdown);
    };
  }, [refetchAuthStatus, fetchProjectNames, fetchChatSessions]);

  // Dropdown project filtering logic
  // let filteredDropdownProjectsForDropdown = projectNames;
  // if (dropdownSearchQuery) {
  //   filteredDropdownProjectsForDropdown = projectNames
  //     .filter((name) =>
  //       name.toLowerCase().includes(dropdownSearchQuery.toLowerCase())
  //     )
  //     .slice(0, 5); // Show up to 5 matching projects
  // } else {
  //   filteredDropdownProjectsForDropdown = projectNames.slice(0, 5); // Show only top 5 by default
  // }

  const handleDropdownToggle = (id: number) => {
    setOpenDropdownMessageId(openDropdownMessageId === id ? null : id); // Toggle dropdown visibility
  };
  const handleClickOutside = (event: MouseEvent): void => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node) && // Click outside the dropdown
      !buttonRef.current?.contains(event.target as Node) // Click outside the dropdown button
    ) {
      setOpenDropdownMessageId(null); // Close the dropdown if click is outside
    }
  };

  useEffect(() => {
    if (dropdownSearchQuery) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  }, [dropdownSearchQuery]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Cleanup event listener
    };
  }, []);

  const copyToClipboard = (text: string) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
  };

  const handleCopy = (text: string, id: number) => {
    copyToClipboard(text.replace(/###|####|---|\*\*/g, ''))
    setCopiedMessageId(id);

    // Hide the tooltip after 8 seconds
    setTimeout(() => setCopiedMessageId(null), 8000);
  };

  const handleShowHistory = () => {
    setShowHistory((prev) => !prev);
  };

  // Handler for selecting a session from history modal
  const handleSelectSessionFromHistory = (
    indexId: number,
    projectId: string,
    totalCount: number,
  ) => {
    setShowHistory(false);
    setShowNavigationArrows(true);
    setSelectedSessionId(projectId);
    setTotalSessionCount(totalCount);
    setCurrentIndexInSession(totalCount); // Start at the latest (bottom)
    replaceChatMessages(projectId, indexId, undefined, totalCount); // Clear current messages

    // fetchAndReplaceChat.mutate(indexId);
    // fetchChatSessions("");
  };

  const handleExpand = () => {
    setIsExpanded((prev) => {
      // Ensure that when expanding, the dropdown is closed
      if (showDropdown) setShowDropdown(false);
      return !prev;
    });
  };

  const findProjectNameById = (id: string) => {
    const projectsToSearch = effectiveProjectsList?.projects;
    if (!projectsToSearch) {
      return "";
    }

    const foundProject = projectsToSearch.find((p) => {
      if ('value' in p) {
        // New structure (ProjectEntity) - match by value
        return String(p.value) === String(id);
      } else {
        // Old structure (Project) - match by _id
        return String(p._id) === String(id);
      }
    });

    if (foundProject) {
      if ('key' in foundProject) {
        // New structure (ProjectEntity) - return key for display
        return foundProject.key;
      } else {
        // Old structure (Project) - return project_name
        return foundProject.project_name;
      }
    }

    return defaultProjectPlaceholder ?? "";
  };

  // Fetch all chat history on drawer open
  useEffect(() => {
    if (isOpen && messagesRef.current.length === 0) {
      setMessagesTrigger((prev) => !prev);
      appendAtEndChatMessages();
    }
  }, [isOpen, appendAtEndChatMessages]);

  const updateMessages = (updater: (prevMessages: Message[]) => Message[]) => {
    messagesRef.current = updater(messagesRef.current);
    setMessagesTrigger((prev) => !prev); // Trigger re-render
  };

  useEffect(() => {
    if (chatMessages && chatMessages.length > 0) {
      const minIndexId = Math.min(
        ...chatMessages.map((item: { index_id: number }) => item.index_id)
      );
      setCurrentIndexId(minIndexId);

      let prevScrollHeight = 0;
      let prevScrollTop = 0;
      let isAtBottom = false;
      if (chatContainerRef.current) {
        prevScrollHeight = chatContainerRef.current.scrollHeight;
        prevScrollTop = chatContainerRef.current.scrollTop;
        isAtBottom =
          Math.abs(
            chatContainerRef.current.scrollHeight -
            chatContainerRef.current.scrollTop -
            chatContainerRef.current.clientHeight
          ) < 5;
      }
      updateMessages(() => chatMessages);
      setTimeout(() => {
        if (chatContainerRef.current) {
          const newScrollHeight = chatContainerRef.current.scrollHeight;
          if (isAtBottom) {
            chatContainerRef.current.scrollTop =
              chatContainerRef.current.scrollHeight;
          } else {
            chatContainerRef.current.scrollTop =
              newScrollHeight - prevScrollHeight + prevScrollTop;
          }
        }
      }, 0);
    }
    // Scroll to bottom if LoadingDots is present
    if (
      messagesEndRef.current &&
      chatMessages.some(
        (msg: any) =>
          msg.sender === "ai" &&
          msg.isTemp &&
          msg.content &&
          typeof msg.content === "object" &&
          msg.content.type &&
          msg.content.type.name === "LoadingDots"
      )
    ) {
      // Use longer timeout when isExpanded is false (dev/qat environments need more time)
      const scrollTimeout = isExpanded ? 0 : 100;
      setTimeout(() => {
       if (messagesEndRef.current && !showScrollButtonRef.current) {
          messagesEndRef.current.scrollIntoView({ behavior: "auto" });
        }
      }, scrollTimeout);
    }
  }, [chatMessages]);

  // Scroll handler for chat container
  const handleChatScroll = () => {
    // Only handle UI changes for scroll, do not load more messages automatically

    const container = chatContainerRef.current;
    if (container) {
      const currentScrollTop = container.scrollTop;

      prevScrollTopRef.current = currentScrollTop;
      prevScrollHeightRef.current = container.scrollHeight;

        const scrolledUp = currentScrollTop < container.scrollHeight - container.clientHeight - 100;
      showScrollButtonRef.current = scrolledUp;
      setShowScrollButton(scrolledUp);

    }



    if (
      chatContainerRef.current &&
      chatContainerRef.current.scrollTop === 0 &&
      !sessionIsOn
    ) {
      if (!showLoadMore) setShowLoadMore(true);
      // Removed: appendAtEndChatMessages(currentIndexId);
    }
  };

  const handleProjectChange = (projectId: string, projectName: string) => {
    setDropdownSelectedProjectId(projectId);
    // Do NOT call setSelectedSessionId here
    // Additional logic when a project is selected
  };

  const handleReply = (
    message: Message,
    selectedSessionId: string,
    message_id: string,
    index_id: number
  ) => {
    setReplyMessage(message);
    setReplyToMessageId(message_id);
    setReplyToIndexId(index_id);

    // Determine if the message is from web mode based on message type
    // Use case-insensitive comparison since backend returns lowercase "web" while frontend uses "Web"
    const messageIsWebEnabled = message.type?.toLowerCase() === "web";

    // Only update IsWebEnabled if it's actually different to avoid unnecessary WebSocket reconnection
    if (IsWebEnabled !== messageIsWebEnabled) {
      setIsWebEnabled(messageIsWebEnabled);
    }

    // Normalize project IDs for comparison (null, undefined, "", "default", and AIAssistantname all mean default/empty)
    const currentProjectId = dropdownSelectedProjectId || "";
    const normalizedNewProjectId = (selectedSessionId === "default" || selectedSessionId === "" || selectedSessionId === AIAssistantname || !selectedSessionId) ? "" : selectedSessionId;

    // Only update project ID if it's actually different to avoid unnecessary WebSocket reconnection
    if (currentProjectId !== normalizedNewProjectId) {
      setDropdownSelectedProjectId(normalizedNewProjectId);
    }
  };

  const {
    // mutate: navigateChatHistory,
    isPending: isNavigating, // v5: mutation isLoading renamed to isPending
    // data: navigationData,
    error: navigationError,
  } = useChatHistoryNavigation();

  const handleNavigate = (action: "up" | "down") => {
    if (!selectedSessionId || currentIndexId === undefined) return;
    setCurrentIndexInSession((prev) => {
      if (action === "up") {
        return prev > 1 ? prev - 1 : 1;
      } else if (action === "down") {
        return totalSessionCount && prev < totalSessionCount ? prev + 1 : prev;
      }
      return prev;
    });
    replaceChatMessages(selectedSessionId, currentIndexId, action, currentIndexInSession);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9998,
            background: "rgba(0,0,0,0.6)",
            pointerEvents: "auto",
          }}
          onClick={() => {
            if (isExpanded) {
              setIsExpanded(false);
              onClose();
            } else {
              setShowHistory(false);
              onClose();
            }
          }}
        />
      )}
      <div
        ref={containerRef}
        className={`chatbotdrawersocket ${styles["drawer"]} ${isOpen ? styles["open"] : styles["hidden"]} ${isExpanded ? styles["expanded"] : ""}`}
      >
        <BeforeExpand
          isSearchFieldNeeded={isSearchFieldNeeded}
          isWorkWebEnableForAll={isWorkWebEnableForAll}
          isWebAllowed={isWebAllowed}
          historyModalRef={historyModalRef}
          defaultProjectPlaceholder={defaultProjectPlaceholder}
          setShowHistory={setShowHistory}
          handleSelectSessionFromHistory={handleSelectSessionFromHistory}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          selectedProject={selectedSessionId}
          setSelectedProject={setSelectedSessionId}
          showDropdown={showDropdown}
          setShowDropdown={setShowDropdown}
          projectsList={effectiveProjectsList}
          agentData={agentData}
          findProjectNameById={findProjectNameById}
          totalSessionCount={totalSessionCount}
          currentIndexInSession={currentIndexInSession}
          handleNavigate={handleNavigate}
          isNavigating={isNavigating}
          navigationError={navigationError}
          messages={messagesRef.current}
          user={setUserObj}
          suggestionPrompts={suggestionPrompts}
          AIAssistantName={AIAssistantname}
          inputValue={inputValue}
          handleSend={handleSend}
          handleInputChange={handleInputChange}
          handleInputKeyDown={handleInputKeyDown}
          handleSuggestionClick={handleSuggestionClick}
          handleMicClick={handleMicClick}
          isListening={isListening}
          listeningDots={listeningDots}
          isMicHovered={isMicHovered}
          setIsMicHovered={setIsMicHovered}
          handleSpeakerClick={handleSpeakerClick}
          handleCopy={handleCopy}
          copiedMessageId={copiedMessageId}
          hoveredButton={hoveredButton}
          handleIconMouseEnter={handleIconMouseEnter}
          handleIconMouseLeave={handleIconMouseLeave}
          handleReply={handleReply}
          openDropdownMessageId={openDropdownMessageId}
          setOpenDropdownMessageId={setOpenDropdownMessageId}
          showLoadMore={showLoadMore}
          dropdownRef={dropdownRef}
          buttonRef={buttonRef}
          chatContainerRef={chatContainerRef}
          messagesEndRef={messagesEndRef}
          isUpdatingSpeakingStateRef={isUpdatingSpeakingStateRef}
          highlightProjectNames={highlightProjectNames}
          handleProjectChange={handleProjectChange}
          handleExpand={handleExpand}
          onClose={onClose}
          handleChatScroll={handleChatScroll}
          showScrollButton={showScrollButton}
          showScrollButtonRef={showScrollButtonRef}
          handleDropdownToggle={handleDropdownToggle}
          showHistory={showHistory}
          handleShowHistory={handleShowHistory}
          chatMessageIsLoading={chatMessageIsLoading}
          aufgangAnimationUrl={aufgangAnimationUrl}
          aufgangAnimationAlt={aufgangAnimationAlt}
          aufMinUrl={aufMinUrl}
          aufMinAlt={aufMinAlt}
          logoVideoUrl={logoVideoUrl}
          chatbotMicIconUrl={chatbotMicIconUrl}
          chatSendIconUrl={chatSendIconUrl}
          chatSendIconWhiteUrl={chatSendIconWhiteUrl}
          sendButtonColor={sendButtonColor}
          sendButtonHoverColor={sendButtonHoverColor}
          sendButtonDisabledColor={sendButtonDisabledColor}
          sendButtonTextColor={sendButtonTextColor}
          workWebToggleActiveBgColor={workWebToggleActiveBgColor}
          workWebToggleInactiveTextColor={workWebToggleInactiveTextColor}
          workWebToggleTextColor={workWebToggleTextColor}
          aiTextIconUrl={aiTextIconUrl}
          openInFullIconUrl={openInFullIconUrl}
          replyChatIconUrl={replyChatIconUrl}
          chatCloseIconUrl={chatCloseIconUrl}
          historyIconUrl={historyIconUrl}
          nonExpandIconUrl={nonExpandIconUrl}
          miconUrl={miconUrl}
          chatMicOffIconUrl={chatMicOffIconUrl}
          chatbotUpArrowUrl={chatbotUpArrowUrl}
          chatbotDownArrowUrl={chatbotDownArrowUrl}
          historyModalConfig={mergedHistoryModalConfig}
          projectSidebarConfig={mergedProjectSidebarConfig}
          loadMoreMessagesText={loadMoreMessagesText}
          loadingMoreMessagesText={loadingMoreMessagesText}
          loadMoreBottomMessages={loadMoreBottomMessages}
          isBottomLoading={isBottomLoading}
          customSuggestionComponent={customSuggestionComponent}
          isHistoryIconVisible={isHistoryIconVisible}
          isProjectDropdownVisible={isProjectDropdownVisible}
          isProjectChangeIconVisible={isProjectChangeIconVisible}
          feedbackBackgroundColor={feedbackBackgroundColor}
          feedbackBorderColor={feedbackBorderColor}
          feedbackTextColor={feedbackTextColor}
          feedbackButtonColor={feedbackButtonColor}
          feedbackButtonHoverColor={feedbackButtonHoverColor}
          feedbackPlaceholderColor={feedbackPlaceholderColor}
          thumbUpIcon={thumbUpIcon}
          thumbDownIcon={thumbDownIcon}
          workModePlaceholder={workModePlaceholder}
          webModePlaceholder={webModePlaceholder}
          listeningPlaceholder={listeningPlaceholder}
          aiThinkingPlaceholder={aiThinkingPlaceholder}
          workLabel={workLabel}
          webLabel={webLabel}
          isExpandableButtonEnable={isExpandableButtonEnable}
          // Google Drive props
          googleTokenData={googleTokenData}
          googleAuthToken={googleAuthToken}
          onGoogleTokenSubmit={onGoogleTokenSubmit}
          onGoogleTokenFetch={onGoogleTokenFetch}
          onGoogleDriveFileIds={onGoogleDriveFileIds}
          showGoogleDriveOption={showGoogleDriveOption}
          stopReconnectionSocket={stopReconnectionSocket}
        />
      </div>
    </>
  );
};

export default ChatDrawer;